import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { ErrorBoundary } from '@common/components'
import { initializeApplicationInsights } from '@common/utils/application-insight'
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js'
import { AppRoutes } from './Routes'
import { appStore } from './app-store'

const reactPlugin = initializeApplicationInsights()

const App = () => (
    <StrictMode>
        <ErrorBoundary>
            <AppInsightsContext.Provider value={reactPlugin}>
                <Provider store={appStore}>
                    <AppRoutes />
                </Provider>
            </AppInsightsContext.Provider>
        </ErrorBoundary>
    </StrictMode>
)

const container = document.getElementById('app')
const root = createRoot(container!)
root.render(<App />)
